import { render } from "./MicPermission.vue?vue&type=template&id=8eb35526&scoped=true&ts=true&lang=pug"
import script from "./MicPermission.vue?vue&type=script&lang=ts"
export * from "./MicPermission.vue?vue&type=script&lang=ts"

import "./MicPermission.vue?vue&type=style&index=0&id=8eb35526&scoped=true&lang=css"

import exportComponent from "E:\\UiDesk\\laragon-5.0.0\\www\\click-to-call\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8eb35526"]])

export default __exports__